import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginForm from './components/LoginForm';
import SignUpForm from './components/SignUpForm';
import CustomerDashboard from './components/CustomerDashboard';
import UserDashboard from './components/UserDashboard';
import CustomerProfile from './components/CustomerProfile';
import AdminSetup from './components/AdminSetup';
import theme from './theme/theme';
import './App.css';

const AppContent: React.FC = () => {
  const { currentUser, loading, isAdmin, isCustomer } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '1.125rem',
        color: '#6b7280'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <div className="App">
      <Routes>
        <Route 
          path="/login" 
          element={currentUser ? <Navigate to="/dashboard" replace /> : <LoginForm />} 
        />
        <Route 
          path="/signup" 
          element={currentUser ? <Navigate to="/dashboard" replace /> : <SignUpForm />} 
        />
        <Route 
          path="/profile" 
          element={currentUser ? <CustomerProfile /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/dashboard" 
          element={
            currentUser ? (
              isAdmin ? <CustomerDashboard /> : <UserDashboard />
            ) : (
              <Navigate to="/login" replace />
            )
          } 
        />
        <Route 
          path="/admin" 
          element={
            currentUser && isAdmin ? (
              <CustomerDashboard />
            ) : currentUser ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          } 
        />
        <Route 
          path="/admin-setup" 
          element={
            currentUser && isAdmin ? (
              <AdminSetup />
            ) : currentUser ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          } 
        />
        <Route 
          path="/" 
          element={currentUser ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />} 
        />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App; 